<template>
  <div class="content-form">
    <div class="columns">
      <div class="field column">
        <InputField
          type="text"
          minlength="2"
          name="username"
          :labelName="$t('driver_onboarding.profile.general.fullname')"
          @onChange="onChangeFullname"
          :errorMessage="isValidFullname.message"
          :showError="isValidFullname.value === false"
          :initValue="fullname"
        />
      </div>
      <div class="field column">
        <BDateField
          @onChange="onChangeDateOfBirth"
          :labelName="$t('driver_onboarding.profile.general.date_of_birth')"
          :maxDate="configuration.max_date"
          :minDate="configuration.min_date"  
          :value="dateOfBirthValue"
          :isVisibleNote="true"
          placeholder="DD/MM/YYYY"
        />

      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="is-flex radio-field">
          <div class="radio-option" :class="{ active: isMale }" @click="changeGender(1)">
            <img v-if="isMale" src="/img/icons/check-processing.svg" width="12" height="10" alt />
            <span>{{$t('driver_onboarding.profile.general.male')}}</span>
          </div>
          <div class="radio-option" :class="{ active: !isMale }" @click="changeGender(0)">
            <img v-if="!isMale" src="/img/icons/check-processing.svg" width="12" height="10" alt />
            <span>{{$t('driver_onboarding.profile.general.female')}}</span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="is-flex radio-field">
          <div class="radio-option" :class="{ active: !isMarried }" @click="changeMarriageStatus(0)">
            <img v-if="!isMarried" src="/img/icons/check-processing.svg" width="12" height="10" alt />
            <span>{{$t('driver_onboarding.profile.general.single')}}</span>
          </div>
          <div class="radio-option" :class="{ active: isMarried }" @click="changeMarriageStatus(1)">
            <img v-if="isMarried" src="/img/icons/check-processing.svg" width="12" height="10" alt />
            <span>{{$t('driver_onboarding.profile.general.married')}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import InputField from "@/components/InputField.vue";
import BDateField from "@/components/BDatePicker";

const TEMPLATE = {
  GENDER: {
    MALE: 'Nam',
    FEMALE: 'Nữ'
  },
  MARRIAGE_STATUS: {
    SINGLE: "Độc thân",
    MARRIED: "Đã kết hôn"
  }
}

export default {
  components: {
    InputField,
    BDateField
  },
  data() {
    const today = new Date();
    return {
      fullname: this.supplierProfile && this.supplierProfile.name || null,
      gender: '',
      dateOfBirth: null,
      marriageStatus: '',

      configuration: {
        max_date: new Date(
          today.getFullYear() - 18,
          today.getMonth(),
          today.getDate()
        ),
        min_date: new Date(
          today.getFullYear() - 60,
          today.getMonth(),
          today.getDate()
        )
      },

      errorMessageUsername: "",
      showErrorUsername: false,    
     
      error: [],
    };
  },  
  computed: {
    ...mapGetters(["formData","supplierProfile"]),
    dateOfBirthValue () {
      const date = this.dateOfBirth
      let result = date
      if (date) {
        const dateArray = date.split('/')
        result = new Date(new Date(`${dateArray[1]}/${dateArray[0]}/${dateArray[2]}`))
      }
      return result
    },
    isMale () {
      return this.gender === TEMPLATE.GENDER.MALE
    },
    isMarried () {
      return this.marriageStatus === TEMPLATE.MARRIAGE_STATUS.MARRIED
    },
    isValidFullname () {
      let result = {
        value: null,
        message: ''
      }
      // if(this.fullname === undefined) return true
      if(this.fullname !== null){
        result.value = this.fullname.length > 2
        result.message = result.value
        ? ''
        : this.$t('driver_onboarding.profile.general.require_min_length')      
      }

      return result  
    },
  },
  methods: {
    setGeneralProfile () {
      this.$store.dispatch('setGeneralProfile', {
        fullname: this.fullname,
        gender: this.gender,
        date_of_birth: this.dateOfBirth,
        marriage_status: this.marriageStatus
      })
    },
    onChangeFullname (value) {
      this.fullname = value
      this.setGeneralProfile()
    },
    onChangeDateOfBirth (value) {
      this.dateOfBirth = `${value.getDate()}/${value.getMonth()+1}/${value.getFullYear()}`
      this.setGeneralProfile()
    },
    changeGender (value) {
      this.gender = value === 1 ? TEMPLATE.GENDER.MALE : TEMPLATE.GENDER.FEMALE
      this.setGeneralProfile()
    },
    changeMarriageStatus (value) {
      this.marriageStatus = value === 1 ? TEMPLATE.MARRIAGE_STATUS.MARRIED : TEMPLATE.MARRIAGE_STATUS.SINGLE
      this.setGeneralProfile()
    }
  },
  created() {
    const formData = this.formData
    if (formData) {
      if(this.supplierProfile && this.supplierProfile.name ){
        formData.fullname  = this.supplierProfile.name 
        this.fullname = this.supplierProfile.name || formData.fullname
      }
      this.dateOfBirth = formData.date_of_birth
      this.gender = formData.gender || TEMPLATE.GENDER.MALE 
      this.marriageStatus = formData.marriage_status || TEMPLATE.MARRIAGE_STATUS.SINGLE
    }
  }  
};
</script>
<style lang="scss">
.radio-field {
  justify-content: space-between;
  .radio-option {
    width: 116px;
    height: 46px;
    text-align: center;
    line-height: 46px;
    background: #f2f2f2;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
  }

  .radio-option.active {
    background: #fff;
    border: 1px solid #ff8200;
    img {
      margin-right: 5px;
    }
  }
}
</style>
